import { useEffect, useState } from 'react';
import arrowUp from 'assets/images/arrow-up.svg';
import './style.scss';

export const ScrollToTop = () => {
  const [showGoTop, setShowGoTop] = useState(false);

  const handleVisibleButton = () => {
    setShowGoTop(window.pageYOffset > 50);
  };

  const handleScrollUp = () => {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleVisibleButton);
  }, []);

  return (
    <div className={showGoTop ? '' : 'goTopHidden'} onClick={handleScrollUp}>
      <button type={'button'} className="goTop">
        <img src={arrowUp} alt="Arrow Up" />
      </button>
    </div>
  );
};
